import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
  } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import './Chart.css';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export default function BarChart(props) {
  return(
    <div height={props.hChart+"px"} style={{"height": props.hChart, "minHeight": "100px"}}>
        <Bar id={props.id} options={props.options} data={props.chartData.data} className="canvasChart"/>
    </div>
  );
}

//<Bar options={props.chartData.options} data={props.chartData.data} />